import React from 'react';
import {Link} from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import MetaTags from "../components/MetaTags";

const Vetochka: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);

    const images = [
        {src: "/image/Cvetochki/kP8020153.jpg"},
        {src: "/image/Schema/kVetka.jpg"},
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Веточка из бисера и стекляруса",
        "Схема плетения веточки из бисера и стекляруса. Цветы и листики делаются на тонкой проволоке, а ствол из толстой проволоки обмотанной зелеными нитками."
    )

    return <>
        <h2>Веточка из бисера и стекляруса</h2>

        <div className="row">
            <div className="col-md-12">
                <p><img
                    src="/image/Cvetochki/mP8020153.jpg" width="227" height="170" className="pic-left img-rounded"
                    alt="Веточка из бисера"
                    id="image-0"
                    onClick={viewImage}
                />
                    Для изготовления веточки нам необходимы цветы и листики на проволоке&nbsp;— они держат форму.</p>
                <p>Из стекляруса делаем тоненький цветок. Для этого наберите на проволоку стеклярусину и бисеринку,
                    затем выведите проволоку через отверстие в стеклярусине вверх и подтяните (рис.А). Первый лепесток
                    готов. Между лепестками набирайте по 1 бисеринке как показано на рисунке Б. Собрав 7 лепестков,
                    замкните кольцо, пропустите оба конца проволоки через бисеринки навстречу друг другу (рис.В). Для
                    того чтобы сделать серединку цветка на один конец лески наберите бусину и бисеринку затем выведите
                    проволоку через отверстие в бусине, протяните через бисеринку на другой стороне цветка и скрутите
                    концы проволоки, чтобы сделать стебелек (рис.Г).</p>
            </div>
        </div>
        <img src="/image/Schema/Cvetok.jpg" className="schema col-centered" width="550" height="237"
             alt="Схема плетения тоненького цветка"/>
        <p>Для листика возьмите зеленый бисер и кусок тонкой проволоки длиной 8&nbsp;— 10 см. Наберите 3 бисеринки
            на средину проволоки и через 2 крайние пропустите концы проволоки навстречу друг другу. Далее делайте
            так как показано на рисунке.</p>

        <img src="/image/Schema/Listik.jpg" width="550" height="100" className="schema col-centered"
             alt="Схема плетения листика"/>
        <div className="row">
            <div className="col-md-12">
                <img src="/image/Schema/Stvol.jpg" width="100" height="300"
                     className="pic-right img-thumbnail" alt="Ствол"/>
                <img src="/image/Schema/Vetka.jpg"
                     width="227" height="200"
                     className="pic-right img-rounded"
                     alt="Ветка"
                     id="image-1"
                     onClick={viewImage}
                />
                <p>Изготовьте 7 цветочков и 7 листиков. Возьмите толстую проволоку, скрутите ее в несколько
                    слоев, чтобы получился прочный ствол. Затем разделите на две веточки и так далее.
                    Сформировав ствол и ветки, начинайте прикреплять цветочки и листики в произвольном порядке,
                    прикручивая концы проволочек к веткам. Чтобы придать веточке более естественный и аккуратный
                    вид обмотайте ее зелеными нитками мулине или любыми другими нитками для вышивания.</p>

            </div>
        </div>
        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>
        ;
};

export default Vetochka;

